export default {"src":"/_next/static/media/3.6e080205.gif","height":720,"width":1280};